import { obterServicosPlanoAsync, obterServicosPlanoPorPeriodicidadeAsync } from "../../services/servicoPlanoService";

const atualizarServicosPlano = async ({ commit }) => {
    const servicosPlano = await obterServicosPlanoAsync();
    commit('atualizarServicosPlano', servicosPlano);
}

const atualizarServicosPlanoPeriodos = async ({ commit }, { idPlano, idPeriodicidade }) => {
    const servicosPlanoPeriodos = await obterServicosPlanoPorPeriodicidadeAsync(idPlano, idPeriodicidade);
    commit('atualizarServicosPlanoPeriodos', servicosPlanoPeriodos);
}

const atualizarServicoPlano = ({ commit }, servicoPlano) => {
    commit('atualizarServicoPlano', servicoPlano);
}

const updateServicoPlano = ({ commit }, servicoPlano) => {
    commit('updateServicoPlano', servicoPlano);
}

export default {
    atualizarServicosPlano,
    atualizarServicoPlano,
    atualizarServicosPlanoPeriodos,
    updateServicoPlano
}